
import { Component, OnInit } from '@angular/core';

import { TokenResponse } from '@openid/appauth';
import { UserInfo } from './models/userinfo';
import { AuthorizationService } from './services/authorization.service';
import { UserIdleService } from 'angular-user-idle';
import { HelperService } from './comman/helper.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'IB Insights';
  public userInfo: UserInfo | null;
  public authorized: boolean;
  private isFirst: boolean = true;
  timeout: number = 15;
  count: number = 0;

  constructor(private userIdle: UserIdleService, private authorizationService:AuthorizationService, private helperService: HelperService) {
  }

  ngOnInit() {
    //Start watching for user inactivity.
    this.userIdle.startWatching();
    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => {
      this.count = count;
      if (this.isFirst == true) {
        let element: HTMLElement = document.getElementById('Logoutwarningbtn') as HTMLElement;
        element.click();
        this.isFirst = false;
      }
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      let closeBtn: HTMLElement = document.getElementById('closeBtn') as HTMLElement;
      closeBtn.click();
      this.signOutUser();
    });
  }

  stop() {
    this.userIdle.stopTimer();
  }

  stopWatching() {
    this.userIdle.stopWatching();
  }

  startWatching() {
    this.userIdle.startWatching();
  }

  reset() {
    this.userIdle.resetTimer();
  }

  stay(){
    this.reset();
    this.startWatching();
    this.isFirst = true;
  }

  signOutUser(){
    this.stopWatching();
    this.reset();
    let isExternal = this.helperService.isExternalUser();
    this.authorizationService.signOut();
    if(isExternal){
    window.location.href = environment.myIBUrl;  
    }
    else{
      window.location.href = environment.ibConnectUrl;;  
    }
  }
}
